// extracted by mini-css-extract-plugin
module.exports = {"box":"box-3AQAHNCJ","exPlanWrapper":"exPlanWrapper-mnB4T4y1"};